<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="proId"
      :itemNames="['name_1','name_2']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :buttonItems="['update']"
    >
      <a-form-item slot="name_1" label="商品ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.productId" placeholder="请输入商品ID"/>
      </a-form-item>
      <a-form-item slot="name_2" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.productName" placeholder="请输入商品名称"/>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <a @click="updateProduct(rowItem.record)">更新产品</a>
      </span>
      <div slot="typeSlots" slot-scope="rowItem">{{ rowItem.text | productTypeName }}</div>
      <a-button
        slot="update"
        style="margin-left: 8px"
        htmlType="submit"
        type="primary"
        @click="submitEvent"
        :loading="submitLoading"
      >全量同步(产品)
      </a-button>
    </search-page-view>
  </a-card>
</template>

<script>
import TuNiuMixins from '@/views/service/serviceProvider/tuNiuConnection/mixins/TuNiuMixins'

export default {
  name: 'TuNiuProductList',
  mixins: [TuNiuMixins],
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      submitLoading: false
    }
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getProService().post('/v2/tuniu/product/all', params)
    },
    getColumns() {
      return [
        {
          title: '商品ID（途牛）',
          dataIndex: 'proProductUrl',
          width: '140px'
        },
        {
          title: '商品ID（魔方）',
          dataIndex: 'proId',
          width: '140px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
          // width: "40%"
        },
        // {
        //   title: '供应商名称',
        //   dataIndex: 'merchantName',
        // },
        {
          title: '类型',
          dataIndex: 'catalogId',
          scopedSlots: { customRender: 'typeSlots' },
          width: '100px'
        },
        {
          title: '同步时间',
          dataIndex: 'proCreateTime',
          width: '160px'
        },
        {
          title: '更新时间',
          dataIndex: 'proUpdateTime',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: '110px',
          fixed: 'right'
        }
      ]
    },
    submitEvent() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getProService().post('/v2/tuniu/sync', this.ruleForm).then(res => {
          this.$message.success('同步成功')
          this.$refs.pageList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    },
    updateProduct(record) { // 更新产品
      this.getHttpServices().getProService().post('/v2/tuniu/single/sync', {
        merchantId: this.$store.getters.userInfo.merchantId,
        productId: record.proProductUrl
      }).then(() => {
        this.$message.success('更新产品成功')
        this.$refs.pageList.refresh()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style scoped>

</style>
